import * as React from "react";
import { FormikProps, getIn } from "formik";
import FormGroup from "@material-ui/core/FormGroup";
import FormPaper from "@components/atoms/FormPaper";
import SectionTitle from "@components/atoms/SectionTitle";
import FormikTextField from "@components/molecules/FormikTextField";
import FormikSwitch from "@components/molecules/FormikSwitch";
import FormikPostalCode from "@components/molecules/FormikPostalCode";
import FormikAddress from "@components/molecules/FormikAddress";
import OfficeField from "@components/v202104/organisms/mgr/common/facility/items/OfficeField";
import ServiceTypeField from "@components/v202104/organisms/mgr/common/facility/items/ServiceTypeField";
import { FacilityValues } from "@initialize/v202104/mgr/KYOTAKUKAIGO/facility/initialValues";
import { UnitsFields } from "@components/v202104/organisms/mgr/KYOTAKUKAIGO/facility/UnitsFields";
import HelpToolTip from "@components/atoms/HelpToolTip";
import HelpTipMessages from "@components/molecules/HelpTipMessages";
import { MultiFunctionMasterSubordinateFormGroup } from "@components/organisms/mgr/common/facility/items/MultiFunctionMasterSubordinateFormGroup";

type Props = {
  isFetchDone: boolean;
  serviceType: string;
  formikProps: FormikProps<FacilityValues>;
  setFormikFieldValue: (
    fieldName: string,
    value: number | string | boolean
  ) => void;
};

export class BasicFields extends React.Component<Props> {
  private onChangeBuildingManagementFlg = (): void => {
    const flg = getIn(
      this.props.formikProps.values,
      "basic.buildingManagementFlg"
    );
    this.props.setFormikFieldValue("basic.buildingManagementFlg", !flg);
  };

  public render(): JSX.Element {
    const disabledBuilding =
      this.props.formikProps.values.units.filter(
        (record) => record.results_use_flg
      ).length > 0;

    return (
      <FormPaper>
        <div style={{ marginBottom: 32 }}>
          <SectionTitle label="基本情報" />
        </div>
        <FormikTextField
          name="basic.corporationName"
          label="法人名"
          placeholder="株式会社ノウビー"
          maxLength={255}
          size="superLong"
        />
        <OfficeField />
        <FormGroup row>
          <ServiceTypeField serviceType={this.props.serviceType} />
        </FormGroup>
        <FormikTextField
          name="basic.representativeName"
          label="代表職員氏名"
          placeholder="山田太郎"
          maxLength={20}
          size="superLong"
        />

        {/* 多機能主従の設定項目 */}
        <MultiFunctionMasterSubordinateFormGroup
          masterSubordinateFlg={
            this.props.formikProps.values.basic.masterSubordinateFlg
          }
          multiFunctionOfficeFlag={
            this.props.formikProps.values.basic.multiFunctionOfficeFlag
          }
          nameOfMasterFlg="basic.masterFlg"
          nameOfMultiFunctionOfficeFlag="basic.multiFunctionOfficeFlag"
        />

        <FormikPostalCode
          name="basic.postalCode"
          label="郵便番号"
          placeholder="000-0000"
          maxLength={8}
          startAdornmentLabel="〒"
        />
        <FormikAddress
          prefectureIdName="basic.prefectureId"
          cityIdName="basic.cityId"
          formikProps={this.props.formikProps}
          showRegionType={false}
          showRegionType202104
        />
        <FormikTextField
          name="basic.restAddress"
          label="市区町村以降の住所"
          size="superLong"
        />
        <FormikTextField
          name="basic.tel"
          type="tel"
          label="電話番号"
          maxLength={12}
          placeholder="0000000000"
          helperText="ハイフンなしで入力"
        />
        <FormGroup>
          <FormikSwitch
            name="basic.buildingManagementFlg"
            label="居住建物を管理する"
            disabled={disabledBuilding}
            tooltip={
              <HelpToolTip
                title={<HelpTipMessages name="buildingManagement" />}
              />
            }
            onChange={this.onChangeBuildingManagementFlg}
          />
          <div
            style={{
              fontSize: 14,
              marginLeft: 32,
              marginBottom: 16,
              marginTop: -20,
              color: "rgba(0, 0, 0, 0.6)"
            }}
          >
            ※同一建物に居住する利用者20人以上、もしくは事業所と同一敷地内建物に居住する利用者がいる場合は設定してください。
          </div>
          {this.props.formikProps.values.basic.buildingManagementFlg && (
            <div style={{ marginLeft: 48, display: "inline" }}>
              <UnitsFields
                formikProps={this.props.formikProps}
                unitLabel="居住建物"
              />
            </div>
          )}
        </FormGroup>
      </FormPaper>
    );
  }
}
